/**
 * Created by fworld on 2019/9/27.
 */
const drink = [
  {
    name: 'delivery.devices.drinkManager',
    path: 'drinkManager',
    meta: {title: '饮品管理'},
    component: () => import('@/pages/Delivery/Device/DrinkManager'),
  },
  {
    name: 'delivery.devices.drinkSort.create',
    path: 'drinkManager/create',
    meta: {title: '饮品品类创建'},
    component: () => import('@/pages/Delivery/Device/DrinkManager/create'),
  },
  {
    name: 'delivery.devices.drinkSort.edit',
    path: 'drinkManager/edit',
    meta: {title: '饮品品类编辑'},
    component: () => import('@/pages/Delivery/Device/DrinkManager/edit'),
  },

]

export default drink
